import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FEATURES } from '../../content/features.js';
import { ABOUT_PATH } from '../../content/site.js';
import './Footer.css';

/**
 * Public site footer: logo, links to the feature pages, contact and "Om oss", then copyright
 * and the organisation number.
 * Add legal links here later.
 * @returns {JSX.Element} Site footer
 */
function Footer() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();
  const email = t('contact.email');

  return (
    <footer className="site-footer">
      <div className="site-footer-content">
        <div>
          <img src="/revetall-logo.svg" alt="Revetall" className="site-footer-logo" />
          <p className="site-footer-tagline">{t('footer.tagline')}</p>
        </div>

        <nav aria-labelledby="footer-pages-title">
          <p className="site-footer-heading" id="footer-pages-title">
            {t('footer.pagesTitle')}
          </p>
          <ul className="site-footer-links">
            {FEATURES.map((feature) => (
              <li key={feature.id}>
                <Link to={feature.path}>{t(`features.${feature.id}.title`)}</Link>
              </li>
            ))}
          </ul>
        </nav>

        <div>
          <p className="site-footer-heading">{t('footer.contactTitle')}</p>
          <ul className="site-footer-links">
            <li>
              <a href={`mailto:${email}`}>{email}</a>
            </li>
            <li>
              <Link to={ABOUT_PATH}>{t('nav.about')}</Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="site-footer-bottom">
        <p className="site-footer-copy">{t('footer.copyright', { year })}</p>
        <p className="site-footer-copy">{t('footer.orgNumber')}</p>
      </div>
    </footer>
  );
}

export default Footer;
